import { useState } from 'react';
import { Box } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import ApiService from '../../../../../ApiService';
import Block from '../../../../../components/Block';

import { AdCreative } from '../../../../../types/AmazonAds';
import { useCampaignPageContext } from '../../../../../hooks/Contexts/Pages/CampaignPageContext';
import CampaignAdCreativeDrawer from '../Drawer/CampaignAdCreativeDrawer';
import CampaignCreativeDataGrid from '../DataGrid/CampaignCreativeDataGrid';
import DspAdCreativeUtils from '../../../../../utils/DspAdCreativeUtils';

const CampaignPageCreativePageTab = () => {
    const { campaign } = useCampaignPageContext();
    const [activeCampaignAdGroupAdCreative, setActiveCampaignAdGroupAdCreative] = useState<AdCreative | undefined>(
        undefined
    );

    const { data, isLoading } = useQuery<AdCreative[]>({
        enabled: !!campaign.id,
        refetchOnWindowFocus: false,
        queryKey: ['campaign/dspAdCreatives', campaign.id],
        queryFn: async () => {
            const { data } = await ApiService.getCampaignAdCreatives(campaign.id as number);

            return await Promise.all(data.map((creative: AdCreative) => DspAdCreativeUtils.toDspAdCreative(creative)));
        },
    });

    return (
        <Box>
            <Block>
                <CampaignCreativeDataGrid
                    rows={data || []}
                    loading={isLoading}
                    action={{
                        name: 'Preview',
                        callback: (dspAdCreative: AdCreative): void => {
                            setActiveCampaignAdGroupAdCreative(dspAdCreative);
                        },
                    }}
                />
            </Block>

            {activeCampaignAdGroupAdCreative && (
                <CampaignAdCreativeDrawer
                    open={!!activeCampaignAdGroupAdCreative}
                    dspAdCreative={activeCampaignAdGroupAdCreative}
                    onCancel={(): void => {
                        setActiveCampaignAdGroupAdCreative(undefined);
                    }}
                    onSave={(): void => {
                        setActiveCampaignAdGroupAdCreative(undefined);
                    }}
                />
            )}
        </Box>
    );
};

export default CampaignPageCreativePageTab;
